<template>
  <button class="btn btn-outline-primary mr-2" @click="doBack">
    <i class="cil cil-arrow-circle-left"></i> {{ label }}
  </button>
</template>

<script>
export default {
  name: "NavBack",
  props: ['label', 'url'],
  methods: {
    doBack () {
      this.$router.push({ path: this.url }).catch(() => { })
    }
  }
}
</script>
